export default "__VITE_ASSET__CJtI2rdr__"